import { render, staticRenderFns } from "./PH15L.vue?vue&type=template&id=a4a590b8&scoped=true"
import script from "./PH15L.vue?vue&type=script&lang=js"
export * from "./PH15L.vue?vue&type=script&lang=js"
import style0 from "./PH15L.vue?vue&type=style&index=0&id=a4a590b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a590b8",
  null
  
)

export default component.exports